import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { RestService } from '../../../../shared/services/rest.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { UserRepository } from '../../../user/states/user.repository';
import { AnimalPreventiveTreatmentModel, AnimalPreventiveTreatmentCreatePayload, AnimalPreventiveTreatmentUpdatePayload } from '../../models/medical/animal-preventive-treatment.model';
import { AnimalMedicalCrudRepository } from './animal-medical-crud.repository';

@Injectable({ providedIn: 'root' })
export class AnimalPreventiveTreatmentRepository extends AnimalMedicalCrudRepository<AnimalPreventiveTreatmentModel, AnimalPreventiveTreatmentCreatePayload, AnimalPreventiveTreatmentUpdatePayload> {
  protected readonly path = '/animal_preventive_treatments';
  protected readonly toastKey = 'treatment';

  constructor(
    restService: RestService,
    toast: ToastService,
    translateService: TranslocoService,
    userRepository: UserRepository
  ) {
    super(restService, toast, translateService, userRepository);
  }
}
